import React, {useState, useEffect} from 'react';
import './style.css';
import { HTMLHint } from 'htmlhint';
import { useNavigate, useLocation } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ContentHeading from '../../components/contentHeading/contentHeading';
import ContentHeadingButton from '../../components/contentHeading/contentHeadingButton';
import { authFetch } from '../../components/authFetch/authFetch';
import { Throbber } from '../../components/throbber/throbber'
import { Link } from 'react-router-dom';

const CampaignDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [statusState, setStatusState] = useState('loading');
    const [campaign, setCampaign] = useState(null);

    const handleGoBack = () => {
        navigate('/');
    };

    const queryParams = new URLSearchParams(location.search);
    const query_campaign_id = queryParams.get("id");

    const formatCampaignData = (data) => {
        console.log(data)
        if (!data || !Array.isArray(data)) {
            console.error("formatCampaignData received invalid data:", data);
            return null;  // ✅ Return an empty array to prevent errors
        }
        const data_formatted = data.map((campaign) => ({
            name: campaign.name,
            subject: campaign.email_template.Title,
            sender_email: campaign.email_template.FromAddress.match(/<([^>]+)>/)?.[1] || "N/A",
            sender_name: campaign.email_template.FromAddress.match(/^(.*?)\s?</)?.[1] || "N/A",
            Type: campaign.campaign_type || "Unknown",
            status: campaign.status || "Unknown",
            html_template: campaign.email_template.HtmlBody
        }));
        console.log(data_formatted[0]);
        return data_formatted[0];
    }

    useEffect(() => {
        authFetch({
            apiMethod: "GET",
            endpoint: "/campaign",
            queryParams: { campaign_id: query_campaign_id },
            onDataLoaded: (data) => {
                setStatusState("success")
                setCampaign(formatCampaignData(data?.campaigns))
            },
            onErrorResponse: (data) => {
                setStatusState("error");
                console.log("error");
            }
        });
    }, []);

    return (
        <div className='campaign-detail-container'>
            {statusState == "loading" && (
                <div className="throbber-overlay">
                    <Throbber />
                </div>
            )}

            <ContentHeading action={
                 <ContentHeadingButton handleContentHeadingButton={handleGoBack} buttonStyleClass="back-button" buttonName="Go Back" />
            } heading="Campaign" />

            <div className='campaign-step step-large'> 
                <div className='email-details'>
                    <h2>Email Message</h2>
                    <div className="content-block">
                        <h3>Campaign Name</h3>
                        <p>{campaign?.name}</p>
                    </div>
                    <div className="content-block">
                        <h3>Status</h3>
                        <p>{campaign?.status}</p>
                    </div>
                    <div className="content-block">
                        <h3>Subject Line</h3>
                        <p>{campaign?.subject}</p>
                    </div>
                    <div className="content-block">
                        <h3>Sender Name</h3>
                        <p>{campaign?.sender_name}</p>
                    </div>
                    <div className="content-block">
                        <h3>Sender Email</h3>
                        <p>{campaign?.sender_email}</p>
                    </div>
                </div>

                <div className='email-preview'>
                    <h2 style={{paddingLeft: '20px'}}>Email Preview</h2>
                    <iframe
                        srcDoc={campaign?.html_template}
                        title="HTML Preview"
                        className="html-preview-iframe"
                    />
                </div>
            </div>
        </div>
    );
};

export { CampaignDetail };
